import { IRoundFinishModel, IRoundReportModel, IRoundStartModel } from '../interfaces/round';
import { betStore, gameStore, roundStore, userStore } from '../stores';
import { RoundStatus } from '../enums/round-status';
import { userService } from './userService';

class RoundService {

  private countdownInterval: any = null;

  startRound = (data: IRoundStartModel) => {
    const now = new Date().getTime();
    const endTime = now + gameStore.roundStartToBetCloseDuration;
    this.startCountdown(endTime);
    betStore.clearCurrentBets();
    betStore.setAllBetsCount(0);
    roundStore.setRoundId(data.id);
    roundStore.setRoundStatus(RoundStatus.Started);
    roundStore.clearOpenedNumbers();
    gameStore.setStatistics(data.statistics);
    gameStore.setLastRounds(data.lastRounds);
  };

  closeBets = () => {
    roundStore.setRoundStatus(RoundStatus.OnHold);
    betStore.setBetToEdit(null);
    betStore.clearSelectedNumbers();
    betStore.setTicketToReBet(null);
    betStore.setHistoryItemToReBet(null);
  }

  finishRound = ({ userWins }: IRoundFinishModel) => {
    const userWin = userWins[userStore.id];
    if (!userWin)
      return;

    userStore.setLastWin(userWin);
    setTimeout(() => {
      userStore.setLastWin(null);
    }, 3000);
    setTimeout(() => {
      userService.updateUserBalance().then();
    }, 500);
  }

  reportRound = (data: IRoundReportModel) => {
    roundStore.addOpenedNumber(data.number);
    const bets = data.bets[userStore.id];
    if (bets) {
      betStore.setCurrentBets(bets);
    }
  }

  startCountdown = (endTime: number) => {
    clearInterval(this.countdownInterval);
    this.countdownInterval = setInterval(() => {
      const distance = endTime - new Date().getTime();
      if (distance >= 0) {
        roundStore.setCountDownDistance(distance);
      } else {
        clearInterval(this.countdownInterval);
      }
    }, 0);
  }

}

export const roundService = new RoundService();
